import { useEffect } from "react";
import { Box } from "@mui/material";
import ExpenseTypeConfiguration from "./ExpenseType/ExpenseTypeConfiguration";
import Base from "../../Base/views/Base";

const ExpenseSettings = () => {
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Base>
      <Box sx={{ height: "calc(100vh - 65px)", overflowY: "auto" }}>
        <ExpenseTypeConfiguration />
      </Box>
    </Base>
  );
};

export default ExpenseSettings;
